<script setup>
import { ref } from "vue";
import { Head, useForm, Link } from "@inertiajs/vue3";
import Input from "@pages/Shared/form/Input.vue";
import Button from "@pages/Shared/form/Button.vue";
import Spinner from "@pages/Shared/ui/Spinner.vue";
import logo from '@/../images/logo.jpg';
import { useLoader } from '@/Stores/useLoader';
import { flashToast } from "@/toast.js";

const form = useForm({ email: "" });
const emailRef = ref(null);
const loader = useLoader();

const submit = () => {
  form.post("/forgot-password", {
    onSuccess: (page) => {
      loader.start();
      setTimeout(() => {
        if (page.props.flash) flashToast(page.props.flash);
      }, 500);
    },
  });
};
</script>

<template>
  <Head title="Forgot Password" />

  <div class="min-h-screen w-full flex items-center justify-center bg-background px-4">
    <div class="w-full max-w-sm">
      <div class="bg-white rounded-lg border border-gray-300 px-8 py-10">

        <div class="flex justify-center mb-6">
          <img :src="logo" alt="Logo" class="w-20 h-20 object-contain" />
        </div>

        <div class="text-center mb-7">
          <h1 class="text-2xl font-bold text-[#0f1929] tracking-tight">Forgot Password?</h1>
          <p class="mt-1.5 text-sm text-gray-500">Enter your email to receive a reset link</p>
        </div>

        <form @submit.prevent="submit" class="flex flex-col gap-5">
          <Input
            ref="emailRef"
            v-model="form.email"
            :error="form.errors.email"
            label="Email"
            placeholder="Email Address"
            type="email"
            autofocus
          />

          <Link href="/login" class="text-xs text-primary underline underline-offset-2 hover:opacity-80 transition-opacity">
            Back to Login
          </Link>

          <Button
            type="submit"
            :disabled="form.processing"
            class="w-full py-2.5 bg-primary hover:bg-primary-light text-white font-semibold rounded-lg transition-colors flex justify-center items-center gap-2 cursor-pointer disabled:opacity-70 shadow-sm"
          >
            <Spinner v-if="form.processing" :size="16" color="white" />
            <span>{{ form.processing ? 'Sending…' : 'Send Link' }}</span>
          </Button>
        </form>

        <p class="mt-8 text-center text-xs text-gray-400">
          &copy; {{ new Date().getFullYear() }} Bn Mas'ud College. All rights reserved.
        </p>

      </div>
    </div>
  </div>
</template>